import { collection, query, where, getDocs, writeBatch } from 'firebase/firestore';
import { db } from './firebase';
import { bestDisplayName } from '../utils/formatters';

// The business card shown on Community tours/routes and their detail pages —
// null unless the owner is a verified business who's opted in
// (profile.useBusinessIdentity). Snapshotted onto each tour/route doc (same
// tradeoff as creatorBadge) so list cards need no extra profile fetch.
export function buildBusinessSnapshot(profile) {
  if (!profile?.useBusinessIdentity || profile.businessVerifiedStatus !== 'verified' || !profile.businessName) return null;
  return {
    name: profile.businessName,
    logoUrl: profile.businessLogoUrl || null,
    website: profile.businessWebsite || null,
    email: profile.businessEmail || null,
    phone: profile.businessPhone || null,
    links: Array.isArray(profile.businessLinks) ? profile.businessLinks : [],
    services: Array.isArray(profile.businessServices) ? profile.businessServices : [],
  };
}

// Re-applies the owner's current business snapshot to every tour and route
// they've already published — so flipping the toggle (or changing the logo)
// updates Community immediately, not just for new listings. Also resets
// userName/userPhoto to the person's own, which repairs any listing created
// while business details briefly overwrote them.
export async function syncBusinessIdentity(user, profile) {
  if (!db || !user) return;
  const business = buildBusinessSnapshot(profile);
  const patch = { business, userName: bestDisplayName(user), userPhoto: user.photoURL || null };

  const [tours, routes] = await Promise.all([
    getDocs(query(collection(db, 'tours'), where('userId', '==', user.uid))),
    getDocs(query(collection(db, 'publishedRoutes'), where('userId', '==', user.uid))),
  ]);
  const refs = [...tours.docs, ...routes.docs].map(d => d.ref);

  for (let i = 0; i < refs.length; i += 400) {
    const batch = writeBatch(db);
    refs.slice(i, i + 400).forEach(ref => batch.update(ref, patch));
    await batch.commit();
  }
}
